// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__13M80","tag-title":"Tag_tag-title__3_s24","tag-close":"Tag_tag-close__9xjXA","addMoreTag":"Tag_addMoreTag__1taHy","addMoreTag-title":"Tag_addMoreTag-title__2igcE"};